import { LinkTabProps, Tab } from './types';

export const getUsersTabLinks = ({ recordId }: LinkTabProps): Tab[] => [
  {
    label: 'Profile',
    to: `/dashboard/admin/users/${recordId}/profile`,
  },
  {
    label: 'Billing',
    to: `/dashboard/admin/users/${recordId}/billing/plan`,
    additionalLinks: [
      `/dashboard/admin/users/${recordId}/billing/invoices`,
      `/dashboard/admin/users/${recordId}/billing/credit-history`,
    ],
  },
];
